import { render, staticRenderFns } from "./AtosAdministrativosPorEnteFederativo.vue?vue&type=template&id=3159bafe&scoped=true"
import script from "./AtosAdministrativosPorEnteFederativo.vue?vue&type=script&lang=js"
export * from "./AtosAdministrativosPorEnteFederativo.vue?vue&type=script&lang=js"
import style0 from "./AtosAdministrativosPorEnteFederativo.vue?vue&type=style&index=0&id=3159bafe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3159bafe",
  null
  
)

export default component.exports